import { Box } from '@chakra-ui/react';
import Navbar from './navbar.js';
import { Outlet, useLocation } from 'react-router-dom';
import Footer from './footer.js';
import { useEffect } from 'react';

const Layout = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If no hash, scroll to top
    if (!hash) {
      window.scrollTo(0, 0);
    }
    // If hash exists, let the Navbar handle the scroll
  }, [pathname, hash]);

  return (
    <Box padding="4" margin="4">
      <Navbar />
      <Outlet />
      <Footer />
    </Box>
  );
};

export default Layout;